import { createApp, h } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import i18n from './i18n'
// import moment from 'moment'
import VueToast from 'vue-toast-notification'
import 'highcharts'
import 'highcharts/modules/exporting'
import 'highcharts/modules/export-data'
import 'highcharts/modules/no-data-to-display'
import 'highcharts/modules/offline-exporting'

// Import one of the available themes
// import 'vue-toast-notification/dist/theme-default.css'
import '@/assets/toasts.css'
import HighchartsVue from 'highcharts-vue'
import baseConfig from '@/AppConfig'
import getApi from './Api'
import 'moment/locale/en-gb'
import '@mdi/font/css/materialdesignicons.css'
import '@fontsource/roboto/index.css'
import 'vue-json-pretty/lib/styles.css'

// Vue.use(vueMoment)
// Vue.use(JsonViewer)

const res = await fetch(`${import.meta.env.VITE_PUBLIC_PATH}config.json`)
const dynamicConfig = await res.json()
baseConfig.url = dynamicConfig.apiUrl
baseConfig.appTitle = dynamicConfig.appTitle
baseConfig.publicPath = dynamicConfig.publicPath

const app = createApp({
  render: () => h(App),
})
app.config.globalProperties.$config = baseConfig
app.config.globalProperties.$api = getApi(baseConfig.url, router)

app.use(store)
app.use(router)
app.use(i18n)
app.use(vuetify)
app.use(VueToast)
app.use(HighchartsVue, { tagName: 'highcharts-vue' })

app.mount('#app')
